import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { PublisherInfo } from '../PublisherInfo';
import { UserReviewInfoProps } from './UserReviewInfo.types';

export const UserReviewInfo = ({
  avatarUrl,
  isCertified,
  microcopy,
  name = '',
  memberSince,
  reviewCount,
  showAvatar,
  publisherLink = '',
  helpfulVoteCount,
  className,
}: UserReviewInfoProps) => {
  return (
    <div className={c(className)}>
      <PublisherInfo
        publisherName={name}
        publisherLink={publisherLink}
        showAvatar={showAvatar}
        isCertified={isCertified}
        microcopy={{ certifiedPublisher: microcopy.certifiedPublisher }}
        publisherAvatarUrl={avatarUrl}
        className="mb-2"
      />
      <ul className="text-sm text-grey-600 [&_li]:mb-1.5">
        {memberSince && (
          <li>
            {interpolateStringWithData(microcopy.memberSince, {
              date: memberSince,
            })}
          </li>
        )}

        {reviewCount && (
          <li>
            {interpolateStringWithData(microcopy.reviewCount, {
              count: reviewCount,
            })}
          </li>
        )}

        {helpfulVoteCount && (
          <li>
            {interpolateStringWithData(microcopy.helpfulVoteCount, {
              count: helpfulVoteCount,
            })}
          </li>
        )}
      </ul>
    </div>
  );
};
